import React from 'react'


/* Create By Poom : 08-06-2023 
  Edit BY POOM : 09-05-2024 
    - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล
	
*/
function Timesheet_Cell_DayTotalTime(props) {

    const { total_wt 
           ,total_ot
           ,total_wt_time_hr
           ,total_wt_time_mm
           ,total_ot_time_hr
           ,total_ot_time_mm
           ,isSVOT
        } = props;

  return (
    <>
        <div className="container-t">
            <div className="container-div">
                <div className="text-bold ">

                    <div className="ml-2">
                        {(total_wt > 0 &&
                        <>
                            {/* {total_wt_time_hr !== "00" &&
                                <>
                                    {total_wt_time_hr}
                                    <span className="text-small text-normal">h</span> 
                                </>
                            } */}

                            {(total_wt_time_hr === "00" || total_wt_time_hr === "0") ? "" : 
                                <>
                                    {total_wt_time_hr.substring(0, 1) === "00" ? 
                                        <>
                                            {total_wt_time_hr.substring(1,2)}
                                           <span  className="text-normal">h</span> 
                                        </> 
                                        : 
                                        <>
                                            {total_wt_time_hr.substring(0, 2)}
                                             <span  className="text-normal">h</span>
                                        </>
                                    }
                                </>
                            }
                            

                            {/* {total_wt_time_mm !== "00" &&
                                <>
                                    {total_wt_time_mm}
                                    <span className="text-small text-normal">m</span> 
                                </>
                            } */}
                            {(total_wt_time_mm === "00" || total_wt_time_mm === "0") ? "" : 
                                <>
                                {" "}
                                    {total_wt_time_mm.substring(0, 1) === "00" ? 
                                        <>
                                            {total_wt_time_mm.substring(1,2)}
                                            <span  className="text-normal">m</span> 
                                        </> 
                                        : 
                                        <>
                                            {total_wt_time_mm.substring(0, 2)}
                                            <span  className="text-normal">m</span>
                                        </>
                                    }
                                </>
                            }




                        </>) ||
                        <>
                            <span className="text-small text-normal">-</span>
                        </>
                        }
                    </div>

                    {isSVOT === true &&
                    <>
                        <div className="ml-2">
                            {(total_ot > 0 &&
                                <>
                                    {/* {total_ot_time_hr !== "00" &&
                                        <>
                                            {total_ot_time_hr}
                                            <span className="text-small text-normal">h</span> 
                                        </>
                                    } */}
                                    {(total_ot_time_hr === "00" || total_ot_time_hr === "0") ? "" : 
                                        <>
                                            {total_ot_time_hr.substring(0, 1) === "00" ? 
                                                <>
                                                    {total_ot_time_hr.substring(1,2)}
                                                     <span  className="text-normal">h</span> 
                                                </> 
                                                : 
                                                <>
                                                    {total_ot_time_hr.substring(0, 2)}
                                                    <span  className="text-normal">h</span> 
                                                </>
                                            }
                                        </>
                                    }

                                    
                                    {(total_ot_time_mm === "00" || total_ot_time_mm === "0") ? "" :
                                        <>
                                        {" "}
                                            {total_ot_time_mm}
                                            <span className="text-normal">m</span>
                                        </>
                                    }
                                </>) ||
                                <>
                                    <span className="text-normal">-</span>
                                </>
                            }
                        </div>
                    
                    </>
                    }
                </div>
            </div>
        </div>
    </>
  )
}

export default Timesheet_Cell_DayTotalTime